import { useState, useEffect, useCallback, useMemo } from 'react';
import { Form } from 'react-bootstrap';
import { db } from '../../firebase';
import { getDocs, collection, doc, updateDoc } from 'firebase/firestore';

export const UnitStatusSelect = ({ issue }) => {
  const [unitStatus, setUnitStatus] = useState(null);
  const [unit, setUnit] = useState(null);

  const UNIT_STATUS = useMemo(() => ({
    ACTIVE: 'active',
    DISABLED: 'disabled'
  }), []);

  const fetchUnitStatus = useCallback(async () => {
    try {
      const unitIDToSearch = issue.Installation.Unit_ID;
      setUnit(unitIDToSearch);
      
      const unitsRef = collection(db, 'units');
      const unitDocsSnapshot = await getDocs(unitsRef);
      const unitsArray = unitDocsSnapshot.docs.map(doc => doc.data());
      
      const currentUnit = unitsArray.find(unit => unit.unitID === unitIDToSearch);
      
      if (currentUnit) {
        setUnitStatus(currentUnit.status);
      } else {
        console.warn(`Unit with ID ${unitIDToSearch} not found.`);
      }
    } catch (error) {
      console.error('Error fetching unit status:', error);
    }
  }, [issue.Installation.Unit_ID]);

  const updateUnitStatus = useCallback(async (newStatus) => {
    try {
      const unitRef = doc(db, 'units', unit);
      await updateDoc(unitRef, { status: newStatus });
      setUnitStatus(newStatus);
      console.log(`Status updated successfully for unit with ID ${unit}. New status: ${newStatus}`);
    } catch (error) {
      console.error('Error updating unit status:', error);
    }
  }, [unit]);

  const handleStatusToggle = useCallback(async () => {
    const newStatus = unitStatus === UNIT_STATUS.ACTIVE ? UNIT_STATUS.DISABLED : UNIT_STATUS.ACTIVE;
    await updateUnitStatus(newStatus);
  }, [unitStatus, updateUnitStatus, UNIT_STATUS]);

  useEffect(() => {
    fetchUnitStatus();
  }, [fetchUnitStatus]);

  // Convert string status to boolean for the toggle
  const isActive = unitStatus === UNIT_STATUS.ACTIVE;

  return (
    <div className='row pb-2'>
      <div className=''>
        <Form.Group className="text-start mt-2" controlId="unitStatusSelect">
          <div className="d-flex align-items-center justify-content-between">
            <Form.Label><strong>UNIT STATUS</strong></Form.Label>
            <div className="d-flex align-items-center gap-3 my-2">
              <Form.Check
                type="switch"
                id="unitStatus-toggle"
                checked={isActive}
                onChange={handleStatusToggle}
              />
              <span style={{ 
                color: isActive ? '#28a745' : '#dc3545',
                fontWeight: 'bold',
                minWidth: '65px',
                textAlign: 'left'
              }}>
                {isActive ? "Active" : "Disabled"}
              </span>
            </div>
          </div>
        </Form.Group>
      </div>
    </div>
  );
};